<template>
    <app-data-table
        :fields="fields"
        :items="tableData"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="actions" slot-scope="{ item }">
            <b-button size="sm" variant="primary" @click="showPeople(item.id)"><i class="fa fa-users" aria-hidden="true"></i>  {{item.people.length}}</b-button>
            <b-button variant="primary" size="sm"  @click="showVehicles(item.id)"><i class="fa fa-car" aria-hidden="true"></i> {{item.vehicles.length}}</b-button> 
            <b-button variant="danger" size="sm"  @click="deleteStructure(item)"><i class="fa fa-trash-o" aria-hidden="true"></i></b-button>
        </template>
    </app-data-table>
</template>
<script>
    export default {
        data() {
            return {
                fields
            }
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            showVehicles: {
                type: Function,
                required: true
            },
            showPeople: {
                type: Function,
                required: true
            },
            deleteStructure: {
                type: Function,
                required: true
            },
            onChangePage: {
                type: Function,
                required: true
            }
        },
        computed: {
            tableData() {
                return !!this.data 
                    && !!this.data.data 
                    && Array.isArray(this.data.data)
                    ? this.data.data
                    : [];
            }
        },
        methods: {
            onSort(ctx) {
                this.$emit('sort', ctx);
            }
        }
    }

const fields = [
                    {
                        key: 'structure_type.name',
                        label: 'Tipo',
                        filter: true
                    },
                    {
                        key: 'name',
                        label: 'Nombre',
                        filter: true
                    },
                    
                    {
                        key: 'venue.name',
                        label: 'Sede',
                        filter: true
                    },
                    {
                        key: 'phone',
                        label: 'Teléfono',
                        filter: true
                    },
                    {
                        key: 'extension',
                        label: 'Extensión',
                        filter: true
                    },               
                    {
                        key: 'email',
                        label: 'E-mail',
                        filter: true
                    },
                    {
                        key: 'actions',
                        label: 'Acciones'
                    }
                ];
</script>